export const CLASSNAME = {
  NOT_TRANSLATE: 'notranslate',
};
